// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"55c81935","787":"0e0ce24c"}[chunkId] + ".chunk.js";
};